import { Textarea } from "ui/components/textarea";
import { cn } from "ui/lib/utils";
import { FormLabel } from "./label";

export function FormTextarea({
  label,
  labelClassName,
  error,
  required,
  className,
  containerClassName,
  readOnly,
  ...props
}) {
  return (
    <div className={cn("flex flex-col space-y-2", containerClassName)}>
      {label && (
        <FormLabel required={required} className={labelClassName}>
          {label}
        </FormLabel>
      )}
      {readOnly ? (
        <p className="text-sm text-muted-foreground">{props.value || "-"}</p>
      ) : (
        <>
          <Textarea
            {...props}
            className={cn(
              error &&
                "border-red-500 focus-visible:ring-red-500 aria-invalid:border-red-500",
              className,
            )}
            aria-invalid={!!error}
          />
          {error && (
            <span className="text-red-500 text-xs font-medium">
              {typeof error === "string"
                ? error
                : error.message || "This field is required"}
            </span>
          )}
        </>
      )}
    </div>
  );
}
